import Input from 'components/cef_form/input';
import React, { useState } from 'react';
import styled from 'styled-components';
import { UploadIcon } from '../../../assets/common_svgs';
import { grey50 } from '../../../../assets/stylesheets/v2/abstracts/_variables.scss';

// TODO Write up jsdocs when functionality gets put in place
/**
 * @param {Object} props
 * @returns stuff
 */
const FilePicker = () => {
  const [inputFile, setInputFile] = useState('');

  return (
    <div className="quick-orders-file-picker__container width-100">
      <div className="p-32 pt-70 pb-70 fl fl-col ai-c">
        <div className="mb-10">
          <UploadIcon fillColor={grey50} width="30" height="40" />
        </div>
        <p className="mb-10 fw-500 fs-16 tc-grey-70">
          {inputFile || 'Choose your file to upload'}
        </p>
        <ChooseFileInput
          type="file"
          className="fl fl-col p-10 mb-10 fw-500 fs-16 jc-c ai-c cef-btn-green--outlined">
          <Input
            type="file"
            inputClassName="d-none"
            handleChange={e => setInputFile(e.target.value.split('\\').pop())}
          />
          {inputFile ? 'Change file' : 'Choose file'}
        </ChooseFileInput>
        <p className="fw-100 fs-12 tc-grey-50">
          Supported formats .XLS, .XLSX and .CSV
        </p>
      </div>
    </div>
  );
};

const ChooseFileInput = styled.label`
  width: 75%;
  input::file-selector-button {
    display: none;
  }
  @media only screen and (min-width: 768px) {
    width: 30%;
  }
`;

export default FilePicker;
